import React, { Component } from 'react';
import Transition from 'react-transition-group/Transition';


import navigation from '../navigation';
import bradLogo from '../assets/img/brad-logo.png';
import resume from '../assets/resume.pdf';

const defaultStyle = {
  transition: `all 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275)`,
  opacity: 0,
  left: "0px"
}

const transitionStyles = {
  entering: { opacity: 0, left: "-100px" },
  entered: { opacity: 1, left:"0px" }
};

class SideBar extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			in: false,
			src: null,
			navContent: navigation[0].locationContent.copy,
			activeNav: 0,
			schoolLocation: null
		}
	}

	componentDidMount() {
		if(!this.props.isMobile) {
			document.addEventListener('mousedown', (event)=>{
				if(this.state.schoolLocation){
					this.jumpToSchool(event, this.state.schoolLocation)
				}
				
			});
		}
        

        document.addEventListener('touchend', (event)=>{
        	console.log(event.target)
        	if(this.state.schoolLocation){
        		this.jumpToSchool(event, this.state.schoolLocation)
        	}
        	
        });
    	if(this.props.details ) {
	    	this.enterState();	
    	}

    	console.log(navigation[0].locationContent.copy)

    }

    

    



    jumpToSchool(event, coords) {
    	console.log(event)
    	let button = document.querySelector('.creative-circus');
    	if(!this.props.isMobile){
    		if(event.target.className === 'creative-circus'){
    			console.log(coords.circus)
    			this.props.jumpTo(coords.circus.coordinates, coords.circus.zoom);
    		}
    		if(event.target.className === 'university-of-kentucky'){
    			console.log(coords)
    			this.props.jumpTo(coords.kentucky.coordinates, coords.kentucky.zoom);
    		}

    	}else {
			if(event.target.className === 'creative-circus'){
				window.open('https://www.instagram.com/explore/locations/216841940/the-creative-circus/','popup', 'width=600,height=600'); return false;
			
			}
			if(event.target.className === 'university-of-kentucky'){
				window.open('https://www.instagram.com/explore/locations/213737144/university-of-kentucky/','popup', 'width=600,height=600'); return false;
			}    		
    	}
		if(event.target.className === 'resume'){
			console.log(coords)
			window.open(resume,'popup', 'width=600,height=600'); return false;
		}    	
    	
    }
    

    handleClickOutside(event) {

    	console.log(this.props)
    	if(this.props.isMobile){
    		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
    		    this.setState({
    		    	in: false
    		    })
    		}
    	}
        
    }
	
	componentWillMount() {
		let image = new Image();
		image.src = bradLogo;
		this.setState({
			src: image.src
		})
	}

	toggleEnterState = () => {
	  this.setState({ in: true });
	}


	

	redirectToLinkedIn() {
		window.open('https://www.linkedin.com/in/bradley-mcgovern-a4681125/', "_blank");
	}


	render(){
		

		const tabBar = navigation.map((tab, i) => {
			const { navTitle, coordinates, jumpToZoom, activateOverlay, content, locationContent, landingContent } = tab;
			return(
				<div className="SideBar__buttonContainer" key={i}>
					<a href="#" className = {i === this.state.activeNav ? 'active' : null} onClick={(e)=> {
						console.log(tab)
						e.preventDefault()
						this.props.jumpTo(coordinates, jumpToZoom);
						this.props.getNavContent(tab);
						this.props.closeDetail();
						if(!this.props.isMobile){
							this.setState({
								activeNav: i,
								navContent: locationContent.copy,
								schoolLocation: landingContent
							})
						} else {
							this.setState({
								activeNav: i,
								navContent: locationContent.mobileCopy,
								schoolLocation: landingContent
							})
						}
						
					}}><span>{navTitle}</span></a>
				</div>
			)
		})

		

		return(
			<Transition
			in={this.state.in}
			timeout={700}>
				{
					(state) =>{
						return(
						<div className="SideBar" 
						ref={this.setWrapperRef}
						style={{
							...defaultStyle,
							...transitionStyles[state]
						}}>
							<div className="SideBar__TopContainer">
								{tabBar}
							</div>

							
							<div className="SideBar__MiddleContainer">
								<div className="landingLogo"
								onClick={()=> this.redirectToLinkedIn()}
								>
									<img 
										src={require('../assets/img/brad-logo.png')} 
										style={{width:"100%", display: 'none'}} 
										onLoad={(e)=>{
											this.props.exitOverlay();
											this.toggleEnterState();
											}
										}
										 alt=""/>	
								</div>
								<div className="Title">
									<h1>Brad M<span className="lowercase">c</span>Govern</h1>
									<h2>Front-end Developer</h2>
								</div>
								<div className="BodyCopy"
								dangerouslySetInnerHTML={{
							       __html: this.state.navContent
							     }}/>
							</div>
							
							<div className="SideBar__BottomContainer">
								<a className="contactInfo" href="mailto:bfmcgo2@gmail.com">Bfmcgo2 at gmail dot com</a>
							</div>

						</div>
					)}

				}
				
			</Transition>
	          	
	    		

				
		)
	}
}

export default SideBar;


// WEBPACK FOOTER //
// ./src/components/SideBar.js